// 第1张
const imgAll1 = {
    JP: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1723604858972/Frame%201000008449.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1723606077486/%E6%B2%B9%E6%9C%BA%E5%85%85.jpg',
    },
    NA: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724644501295/a2.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1724644502115/b2.jpg',
    },
    EU: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725153965550/euPC4.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725153965199/euH4.jpg',
    },
    UK: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725160503682/ukPC4.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725160504414/ukH4.jpg',
    },
};
const imgLocale1: any = {
    jp: imgAll1.JP,
    us: imgAll1.NA,
    ca: imgAll1.NA,
    br: imgAll1.NA,
    mx: imgAll1.NA,
    uk: imgAll1.UK,
    eu: imgAll1.EU,
    de: imgAll1.EU,
    fr: imgAll1.EU,
    it: imgAll1.EU,
    es: imgAll1.EU,
    nl: imgAll1.EU,
};
export default imgLocale1;
